import { Button } from '@alifd/next';
import { createElement, useState } from 'react';
import './index.scss';
const CardPanel = function CardPanel({ text, description, colorEnter, colorLeave, color, style: styleOption = {}, ...otherProps }) {
    const [style, styleSet] = useState(styleOption);
    const colorTransform = (sHex) => {
        const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
        let sColor = sHex.toLowerCase();
        if (sColor && reg.test(sColor)) {
            if (sColor.length === 4) {
                let sColorNew = '#';
                for (let i = 1; i < 4; i += 1) {
                    sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
                }
                sColor = sColorNew;
            }
            const sColorChange = [];
            for (let i = 1; i < 7; i += 2) {
                sColorChange.push(parseInt(`0x${sColor.slice(i, i + 2)}`));
            }
            return `rgba(${sColorChange.join(',')},0.4)`;
        }
        return sColor;
    };
    const mousterEnterBag = () => {
        styleSet({
            ...style,
            background: colorEnter,
            boxShadow: `0 8px 24px 0 ${colorTransform(colorEnter)}`,
            titleColor: '#fff',
            textColor: '#fff',
            btnType: 'secondary',
            imgOpacity: 1,
        });
    };
    const mousterLeaveBag = () => {
        styleSet({
            ...style,
            background: colorLeave,
            boxShadow: `0 0 0 0 ${colorTransform(colorLeave)}`,
            titleColor: '#1f1f1f',
            textColor: '#79889b',
            btnType: 'normal',
            imgOpacity: 0,
        });
    };
    const link = () => {
        window.open(href, '_blank');
    };
    return (createElement("div", { style: { ...styleOption, ...style }, className: "card-panel card-panel-active", onMouseEnter: mousterEnterBag, onMouseLeave: mousterLeaveBag },
        createElement("div", null,
            createElement("div", { className: "card-panel-title", style: { color: style.titleColor } }, text),
            createElement("div", { className: "card-panel-text", style: { color: style.textColor } }, description),
            createElement(Button, { type: style.btnType, className: "card-panel-btn", onClick: link }, "\u8BE6\u60C5")),
        createElement("div", { className: "card-panel-img card-panel-img-active", style: { opacity: style.imgOpacity } })));
};
export default CardPanel;
